export default "__VITE_ASSET__CoJ2lpsU__"